import styled from 'styled-components/macro'
import { Row as AntRow } from 'styled-bootstrap-grid'

export const Row = styled(AntRow)<{ marginV?: number }>`
  margin-top: ${({ marginV }) => (marginV ? `${marginV}px` : 'inherit')};
  margin-bottom: ${({ marginV }) => (marginV ? `${marginV}px` : 'inherit')};
`
